import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
   addVendorChildApi,
   addVendorMasterApiCall,
   contactPersonDetailsApiCall,
   getAllLaneApiCall,
   handleLocationMasterList,
   laneMasterDetailsApiCall,
   listVendorMasterApiCall,
   singleVendorMasterApiCall,
   updateVendorApi,
   updateVendorChildApi,
} from "../../Api/api";

// initial state
const initialState = {
   dataList: [],
   laneData: [],
   locationData: [],
   contactPersonData: {},
   laneMasterData: [],
   singleVendorMaster: {},
   isLoading: false,
   isError: false,
   isSuccess: false,
};
// Fetch location list
export const fetchAllLocationAsync = createAsyncThunk(
   "vendorMaster/fetchAllLocation",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await handleLocationMasterList();
         if (response?.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);
// Fetch lane list
export const fetchAllLaneAsync = createAsyncThunk(
   "vendorMaster/fetchAllLane",
   async ({ done, err }, thunkAPI) => {
      try {
         const response = await getAllLaneApiCall();
         if (response?.data?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err();
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Add vendor
export const addVendorMasterAsync = createAsyncThunk(
   "vendorMaster/addVendorMaster",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await addVendorMasterApiCall(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);
// Fetch Vendor list
export const listVendorMasterAsync = createAsyncThunk(
   "vendorMaster/fetchVendorList",
   async ({ done, err }, thunkAPI) => {
      try {
         const { data: response } = await listVendorMasterApiCall();
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);
// Fetch contactPerson deatils
export const fetchContactPersonDetailsAsync = createAsyncThunk(
   "vendorMaster/fetchContactPersonDetails",
   async (data, thunkAPI) => {
      try {
         const response = await contactPersonDetailsApiCall(data);
         if (response?.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Fetch single vendorMaster
export const fetchSingleVendorMasterAsync = createAsyncThunk(
   "vendorMaster/singleVendor",
   async ({ id, done, err }, thunkAPI) => {
      try {
         const { data: response } = await singleVendorMasterApiCall(id);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);
// Fetch lane master details
export const fetchLaneMasterDetailsAsync = createAsyncThunk(
   "vendorMaster/fetchLaneMasterDetails",
   async (data, thunkAPI) => {
      try {
         const response = await laneMasterDetailsApiCall(data);
         if (response?.data?.statusCode === 200) {
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         thunkAPI.rejectWithValue(error?.response?.data);
         throw error?.response?.data;
      }
   }
);

// Update child contact/lane
export const updateVendorChildAsync = createAsyncThunk(
   "vendorMaster/updateChild",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await updateVendorChildApi(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Add child
export const addVendorChildAsync = createAsyncThunk(
   "vendorMaster/addContact",
   async ({ data, done, err }, thunkAPI) => {
      try {
         const { data: response } = await addVendorChildApi(data);
         if (response?.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.data?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

// Update vendor
export const updateVendorAsync = createAsyncThunk(
   "vendorMaster/UpdateVendor",
   async ({ data, err, done }, thunkAPI) => {
      try {
         const { data: response } = await updateVendorApi(data);
         if (response.statusCode === 200) {
            done && done();
            return thunkAPI.fulfillWithValue(response?.res);
         } else {
            throw response;
         }
      } catch (error) {
         
         err && err(error.message);
         return thunkAPI.rejectWithValue(error);
      }
   }
);

const vendorMasterSlice = createSlice({
   name: "vendorMaster",
   initialState,

   reducers: {
      clearVendorMaster: (state, action) => {
         state.isLoading = false;
         state.isError = false;
         state.isSuccess = false;
      },
   },

   extraReducers: (builder) => {
      //Location
      builder.addCase(fetchAllLocationAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllLocationAsync.fulfilled, (state, action) => {
         state.locationData = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchAllLocationAsync.rejected, (state, action) => {
         state.isLoading = false;
         state.isError = action.payload;
      });
      // Lane
      builder.addCase(fetchAllLaneAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchAllLaneAsync.fulfilled, (state, action) => {
         state.laneData = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchAllLaneAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });

      // List Vendor Master
      builder.addCase(listVendorMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(listVendorMasterAsync.fulfilled, (state, action) => {
         state.dataList = action.payload;
         state.isLoading = false;
      });
      builder.addCase(listVendorMasterAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });

      // Contact person
      builder.addCase(fetchContactPersonDetailsAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchContactPersonDetailsAsync.fulfilled, (state, action) => {
         state.contactPersonData = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchContactPersonDetailsAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });

      // Lane master data
      builder.addCase(fetchLaneMasterDetailsAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchLaneMasterDetailsAsync.fulfilled, (state, action) => {
         state.laneMasterData = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchLaneMasterDetailsAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });

      // single Vendor master
      builder.addCase(fetchSingleVendorMasterAsync.pending, (state, action) => {
         state.isLoading = true;
      });
      builder.addCase(fetchSingleVendorMasterAsync.fulfilled, (state, action) => {
         state.singleVendorMaster = action.payload;
         state.isLoading = false;
      });
      builder.addCase(fetchSingleVendorMasterAsync.rejected, (state, action) => {
         state.isError = action.payload;
         state.isLoading = false;
      });
   },
});

export const { clearVendorMaster } = vendorMasterSlice.actions;
const vendorMasterReducer = vendorMasterSlice.reducer;
export default vendorMasterReducer;
